// src/pages/vendors/purchase-order-form-components/POActionsSection.jsx
import React from 'react';
import {
  Box,
  Button,
  alpha,
  useTheme
} from '@mui/material';
import {
  Save as SaveIcon,
  Cancel as CancelIcon,
  ArrowBack as ArrowBackIcon
} from '@mui/icons-material';

const POActionsSection = ({ isEdit, saving, onSave, onCancel, onBack }) => {
  const theme = useTheme();

  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: 2,
      mt: 4,
      mb: 4
    }}>
      {/* Left: Back */}
      <Button
        variant="outlined"
        startIcon={<ArrowBackIcon />}
        onClick={onBack}
        sx={{
          borderRadius: 3,
          border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
          color: 'text.secondary',
          fontWeight: 500,
          fontSize: '0.9rem',
          px: 3,
          py: 1.5,
          background: 'white',
          '&:hover': {
            color: 'primary.main',
            border: `1px solid ${theme.palette.primary.main}`,
          },
          transition: 'all 0.2s ease'
        }}
      >
        Back to Purchase Orders
      </Button>

      {/* Right: Cancel + Save */}
      <Box sx={{ display: 'flex', gap: 2 }}>
      <Button
        variant="outlined"
        startIcon={<CancelIcon />}
        onClick={onCancel}
        disabled={saving}
        sx={{
          borderRadius: 3,
          border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
          color: 'text.primary',
          fontWeight: 500,
          fontSize: '0.9rem',
          px: 4,
          py: 1.5,
          background: 'white',
          '&:hover': {
            background: alpha(theme.palette.grey[100], 0.8),
            transform: 'translateY(-2px)',
            border: `1px solid ${theme.palette.primary.main}`,
            boxShadow: `0 4px 16px ${alpha(theme.palette.grey[900], 0.15)}`
          },
          transition: 'all 0.3s ease'
        }}
      >
        Cancel
      </Button>
      <Button
        variant="contained"
        startIcon={<SaveIcon />}
        onClick={onSave}
        disabled={saving}
        sx={{
          borderRadius: 3,
          px: 4,
          py: 1.5,
          fontSize: '0.9rem',
          fontWeight: 500,
          border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
          background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
          boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.25)}`,
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: `0 4px 16px ${alpha(theme.palette.primary.main, 0.35)}`
          },
          '&:disabled': {
            background: alpha(theme.palette.primary.main, 0.5),
            border: `1px solid ${alpha(theme.palette.primary.main, 0.3)}`
          },
          transition: 'all 0.3s ease'
        }}
      >
        {saving ? 'Saving...' : (isEdit ? 'Update Purchase Order' : 'Save Purchase Order')}
      </Button>
      </Box>
    </Box>
  );
};

export default POActionsSection;